/* eslint-disable */ import { DomainBuilder, DomainComponentOpticBuilder, InvariantBuilder, RecipeFactoryBuilder, commonAdminCustomExpressions, commonAdminViolationExpressions, createConstantExpressionFactory, createCustomExpressionFactory, createCustomInvariantFactory, createRelationFactory } from '@salsita-ai/platform-project-sdk/domain';
import { $entityReflections, constants } from './admin-enhanced-model.js';
import { AnyDomainEntity, RootEntity, aliases, entities, modelVersion } from './admin-model/index.js';
import { FrontendData, PublishedData, SessionData } from './application-types.js';
const implementRelation = createRelationFactory(aliases);
export const relationExpressions = {
    Admin: {
        $pricingItems: implementRelation({
            kind: 'allOfType',
            target: 'PricingItem',
            cardinality: '0-N'
        }),
        $cabinets: implementRelation({
            kind: 'allOfType',
            target: 'Cabinet',
            cardinality: '0-N'
        }),
        $parts: implementRelation({
            kind: 'allOfType',
            target: 'Part',
            cardinality: '0-N'
        }),
        $appliances: implementRelation({
            kind: 'allOfType',
            target: 'Appliance',
            cardinality: '0-N'
        }),
        $presets: implementRelation({
            kind: 'allOfType',
            target: 'Preset',
            cardinality: '0-N'
        }),
        $presetCategories: implementRelation({
            kind: 'allOfType',
            target: 'PresetCategory',
            cardinality: '0-N'
        }),
        $recipes: implementRelation({
            kind: 'allOfType',
            target: 'Recipe',
            cardinality: '0-N'
        })
    },
    PresetCategory: {
        $admin: implementRelation({
            kind: 'allOfType',
            target: 'Admin',
            cardinality: '1-1'
        }),
        $presets: implementRelation({
            kind: 'indirect',
            field: 'categoryId',
            target: 'Preset',
            cardinality: '0-N'
        })
    },
    Preset: {
        $admin: implementRelation({
            kind: 'allOfType',
            target: 'Admin',
            cardinality: '1-1'
        }),
        $category: implementRelation({
            kind: 'direct',
            field: 'categoryId',
            target: 'PresetCategory',
            cardinality: '0-1'
        })
    },
    Recipe: {
        $admin: implementRelation({
            kind: 'allOfType',
            target: 'Admin',
            cardinality: '1-1'
        })
    }
};
export const constantExpressions = createConstantExpressionFactory({} // insert expression metas here, once ready
)(constants);
export const createAdminRecipe = RecipeFactoryBuilder.forAliases(aliases).forEntities(AnyDomainEntity.reflections).withDefaults({}).build();
const staticViolations = {};
export const implementCustomAdminInvariants = createCustomInvariantFactory()(staticViolations);
export const adminInvariantBuilder = new InvariantBuilder(aliases).withInvariants(implementCustomAdminInvariants(commonAdminViolationExpressions));
export const attachAdminComponent = DomainComponentOpticBuilder.from(aliases);
export const implementAdminCustomExpressions = createCustomExpressionFactory({} // TODO pass in meta-data once we have them
);
export const adminDomainBuilder = DomainBuilder.from(entities, aliases, $entityReflections, RootEntity.types, modelVersion, PublishedData, SessionData, FrontendData, undefined, true).withExpressions(constantExpressions).withExpressions(relationExpressions).withExpressions(implementAdminCustomExpressions(commonAdminCustomExpressions));

//# sourceMappingURL=admin-implementation.js.map